import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/ziti/global.css'

import ElementUI from 'element-ui';             //全局引入element
import 'element-ui/lib/theme-chalk/index.css';    //全局引入element的样式
Vue.use(ElementUI);     //全局注入element
// echarts
// 引入echarts
import * as echarts from 'echarts'
import 'echarts-gl';

Vue.prototype.$echarts = echarts

import tableScroll from './directives/tableScroll.js'
import tableLeftScroll from './directives/tableLeftScroll.js'
Vue.directive('tableScroll', tableScroll) // 注册自定义指令
Vue.directive('tableLeftScroll', tableLeftScroll) // 注册自定义指令
import VueSeamlessScroll from 'vue-seamless-scroll'
Vue.use(VueSeamlessScroll)



import VueParticles from '@/lib/vue-particles'  
 
Vue.use(VueParticles)  




import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'eNry5NgS1y86oDazDVGYRAPyUS2acsGN'
})



import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(VueAxios, axios) 
Vue.prototype.$ajax=axios
Vue.prototype.$http = axios

import { checkLogin } from './utils/auth'

// 初始化：先登录再挂载 Vue
async function initApp() {
  let loginError = null
  try {
    await checkLogin()
  } catch (e) {
    loginError = e
    console.error('[app] 登录失败:', e)
  }
  // 登录失败时显示明确的错误页，避免页面被 401 拦截逻辑瞬间跳回登录页、看不清原因
  if (loginError) {
    const msg = (loginError && loginError.message) ? loginError.message : String(loginError)
    const wrap = document.createElement('div')
    wrap.style.cssText = 'position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;background:#0c1225;color:#fff;font-family:Microsoft YaHei,sans-serif;'
    wrap.innerHTML =
      '<div style="text-align:center;max-width:640px;padding:40px;">' +
      '<h2 style="margin:0 0 16px;font-size:22px;">大屏登录失败</h2>' +
      '<p id="loginErrMsg" style="word-break:break-all;color:#f56c6c;margin:0 0 24px;font-size:14px;line-height:1.6;"></p>' +
      '<button onclick="location.reload()" style="padding:8px 28px;background:#409eff;border:none;border-radius:4px;color:#fff;cursor:pointer;font-size:14px;">刷新重试</button>' +
      '</div>'
    document.body.appendChild(wrap)
    document.getElementById('loginErrMsg').textContent = msg
    return
  }
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
initApp()
